export const VERIFICATION_CONTINUE_URL = 'https://app.taptap.org.uk/verification-complete.html';
